module.exports = "<div class=review-info ng-class=\"{'box-visible': $ctrl.visible, 'enable-animation': $ctrl.enableAnimation}\"> <div class=slide-in-handle ng-click=$ctrl.toggle() translate>Comments</div> <div class=review-info-box-content> <ng-transclude></ng-transclude> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/widgets/reviewinfo/base_partial.html
// module id = 554
// module chunks = 0